module.exports = __webpack_public_path__ + "img/icon-bohui.3a76aa9c.png";